import { Criticality, DiagnosticsMeasurementOverview, FillLevelMeasurements, Product } from '@/generated/fleetAggregationServiceTypes';
import { OverviewRow } from './OverviewRow';

type OverviewTableProps = {
    overview: DiagnosticsMeasurementOverview;
    engineOil?: FillLevelMeasurements;
    product?: Product;
    statusMessageIds?: Partial<Record<Criticality, string>>;
};

export const OverviewTable = ({ overview, engineOil, product, statusMessageIds }: OverviewTableProps) => (
    <table className="table table-condensed">
        <tbody>
            {!overview.danger && !overview.warning && !!overview.normal && (
                <OverviewRow criticality={Criticality.Normal} engineOil={engineOil} product={product} statusMessageId={statusMessageIds?.[Criticality.Normal]} />
            )}
            {!!overview.danger && (
                <OverviewRow
                    criticality={Criticality.Danger}
                    count={overview.danger}
                    engineOil={engineOil}
                    product={product}
                    statusMessageId={statusMessageIds?.[Criticality.Danger]}
                />
            )}
            {!!overview.warning && (
                <OverviewRow
                    criticality={Criticality.Warning}
                    count={overview.warning}
                    engineOil={engineOil}
                    product={product}
                    statusMessageId={statusMessageIds?.[Criticality.Warning]}
                />
            )}
            {!!overview.unknown && (
                <OverviewRow
                    criticality={Criticality.Unknown}
                    count={overview.unknown}
                    engineOil={engineOil}
                    product={product}
                    statusMessageId={statusMessageIds?.[Criticality.Unknown]}
                />
            )}
        </tbody>
    </table>
);
